import React from "react";
import { Box, TextField } from "@mui/material";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { Field } from "react-final-form";
import moment from "moment";
import { momentFromWorkoutTimestamp } from "../../utils/workoutDate";

/**
 * Shared workout metadata fields for workout forms.
 */
const WorkoutMetaFields = ({
  form,
  showDescription = true,
  showDate = true,
  showProgramFields = true,
  nameLabel = "Name",
  descriptionLabel = "Description",
  dateLabel = "Date",
}) => {
  return (
    <>
      <Box sx={{ mt: 1 }}>
        <Field
          name="name"
          subscription={{ value: true }}
          render={({ input }) => (
            <TextField
              {...input}
              label={nameLabel}
              size="small"
              fullWidth
              sx={{ mt: 1 }}
            />
          )}
        />
      </Box>

      {showProgramFields && (
        <Box sx={{ display: "flex", gap: 2, mt: 2, flexWrap: "wrap" }}>
          <Field
            name="currentWeek"
            subscription={{ value: true, touched: true, error: true }}
            render={({ input, meta }) => (
              <TextField
                {...input}
                label="Current Week"
                type="number"
                size="small"
                sx={{ width: 150 }}
                inputProps={{ min: 1 }}
                error={meta.touched && meta.error}
                helperText={meta.touched && meta.error}
              />
            )}
          />
          <Field
            name="programLength"
            subscription={{ value: true, touched: true, error: true }}
            render={({ input, meta }) => (
              <TextField
                {...input}
                label="Program Length (weeks)"
                type="number"
                size="small"
                sx={{ width: 180 }}
                inputProps={{ min: 1 }}
                error={meta.touched && meta.error}
                helperText={meta.touched && meta.error}
              />
            )}
          />
        </Box>
      )}

      {showDescription && (
        <Field
          name="description"
          subscription={{ value: true }}
          render={({ input }) => (
            <TextField
              {...input}
              label={descriptionLabel}
              size="small"
              multiline
              rows={2}
              sx={{ mt: 1 }}
              fullWidth
            />
          )}
        />
      )}

      {showDate && (
        <Field
          name="date"
          render={({ input }) => (
            <DatePicker
              value={
                input.value == null
                  ? null
                  : moment.isMoment(input.value)
                    ? input.value
                    : momentFromWorkoutTimestamp(input.value)
              }
              label={dateLabel}
              onChange={(newValue) => form.change("date", newValue)}
              slotProps={{
                textField: {
                  size: "small",
                  fullWidth: true,
                  margin: "normal",
                  error: false,
                  helperText: "",
                },
                popper: {
                  placement: "bottom-start",
                  modifiers: [
                    {
                      name: "preventOverflow",
                      enabled: true,
                    },
                  ],
                },
              }}
              disableFuture={false}
              disablePast={false}
              showDaysOutsideCurrentMonth={true}
              reduceAnimations={true}
            />
          )}
        />
      )}
    </>
  );
};

export default WorkoutMetaFields;

